import * as THREE from 'three'
import React, { useMemo } from 'react'
import { extrudeSettings } from '../../../../../../../utils/Functions';

const WindowModel = ({ width, height, trimWidth, doorColor, glassTexture }) => {  
    
    const glassWidth = (width - trimWidth * 2) / 2;
    const glassHeight = (height / 2 - height / 10) * 2
    const glassModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-(glassWidth / 2 - glassWidth / 10),  glassHeight / 2);
        model.lineTo(-(glassWidth / 2 - glassWidth / 10),  -glassHeight / 2);
        model.lineTo((glassWidth / 2 - glassWidth / 10),  -glassHeight / 2);
        model.lineTo((glassWidth / 2 - glassWidth / 10),  glassHeight / 2);
        model.closePath();

        return model;
    }, [glassWidth, glassHeight])

    const windowRailModel = useMemo(() => {
        const trimThickness = 0.06;
        const trimWidth = glassWidth - 0.05;
        const trimHeight = glassHeight - 0.05;

        const distanceX = glassWidth / 3.7;
        const distanceY = glassHeight / 5;
        
        let model = []

        for(let i = 0; i < 2; i++) {
            const rail_X = new THREE.Shape();
            rail_X.moveTo(-trimThickness / 2 + Math.pow(-1, i) * distanceX / 2, -trimHeight / 2);
            rail_X.lineTo(-trimThickness / 2 + Math.pow(-1, i) * distanceX / 2, trimHeight / 2);
            rail_X.lineTo(trimThickness / 2 + Math.pow(-1, i) * distanceX / 2, trimHeight / 2);
            rail_X.lineTo(trimThickness / 2 + Math.pow(-1, i) * distanceX / 2, -trimHeight / 2);
            rail_X.closePath();

            model.push(rail_X);
        }

        for(let i = 0; i < 2; i++) {
            for(let j = 0; j < 2; j++) {
                const rail_Y = new THREE.Shape();
                rail_Y.moveTo(-trimWidth / 2, -trimThickness / 2 + Math.pow(-1, i) * distanceY / 2 * (1 + j * 2));
                rail_Y.lineTo(-trimWidth / 2, trimThickness / 2 + Math.pow(-1, i) * distanceY / 2 * (1 + j * 2));
                rail_Y.lineTo(trimWidth / 2, trimThickness / 2 + Math.pow(-1, i) * distanceY / 2 * (1 + j * 2));
                rail_Y.lineTo(trimWidth / 2, -trimThickness / 2 + Math.pow(-1, i) * distanceY / 2 * (1 + j * 2));
                rail_Y.closePath();

                model.push(rail_Y);
            }
        }

        return model;
    }, [glassHeight, glassWidth])
    
    return (
        <group>
            <mesh name='glass' position={[0, 0, 0.05]}>
                <extrudeGeometry args={[glassModel, extrudeSettings(0.15)]} />
                <meshPhongMaterial envMap={glassTexture} side={THREE.DoubleSide} reflectivity={1} />
            </mesh>
            <mesh name='glass-rail' position={[0, 0, 0.025]}>
                <extrudeGeometry args={[windowRailModel, extrudeSettings(0.2)]} />
                <meshStandardMaterial  color={doorColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} />
            </mesh>
        </group>
    )
}

export default WindowModel